import {useNavigation} from '@react-navigation/native';
import {Button, Text} from '@ui-kitten/components';
import React from 'react';
import {
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
  Dimensions,
  Platform,
} from 'react-native';
import {starBanner} from '../../../../../assets/images';
import {px, useIsLandscape} from '../../../../../utils';

const {width} = Dimensions.get('window');

const PackageCard = ({data, onClickRoute, disabled}) => {
  const navigation = useNavigation();
  const isLandscape = useIsLandscape();
  const {
    image,
    onPress,
    subtitle,
    description,
    heading,
    discount,
    disabled: actionDisabled,
  } = data;
  const {titleText, subTitleText} = heading;

  const handleOnPress = () => {
    if (typeof onPress === 'function') {
      onPress(data);
    } else {
      navigation.navigate(onClickRoute, {data});
    }
  };

  var headingFontSize = isLandscape ? px(26) : px(18);
  var lineHeightSize = isLandscape ? px(35) : px(20);

  return (
    <TouchableOpacity disabled={disabled} onPress={handleOnPress}>
      <View
        style={[
          styles.container,
          isLandscape
            ? {
                maxWidth: px(500),
                marginLeft: px(20),
                marginRight: px(20),
                marginBottom: px(20),
              }
            : {
                marginRight: px(10),
                marginBottom: px(20),
              },

          actionDisabled ? styles.disabled : undefined,
        ]}>
        <View style={[styles.card]}>
          <View
            style={[styles.cardImage, {width: isLandscape ? px(80) : px(80)}]}>
            <Image
              source={image}
              defaultSource={starBanner}
              resizeMode="contain"
              style={isLandscape ? styles.desktopImage : styles.mobileImage}
            />
          </View>
          <View style={[styles.cardHeading]}>
            {Boolean(titleText) && (
              <Text
                style={[
                  styles.headingTitletext,
                  {lineHeight: lineHeightSize},
                  {fontSize: headingFontSize},
                ]}>
                {titleText}
              </Text>
            )}
            {Boolean(subTitleText) && (
              <Text style={styles.headingSubTitletext}>{subTitleText}</Text>
            )}
          </View>
        </View>
        <View style={[styles.cardInfo]}>
          {Boolean(subtitle) && <Text style={styles.text2}>{subtitle}</Text>}
          {Boolean(description) && (
            <Text style={styles.text3}>{description}</Text>
          )}
          <Button
            onPress={handleOnPress}
            size="small"
            disabled={actionDisabled}
            style={[styles.button]}>
            {(evaProps) => (
              <Text {...evaProps} style={[evaProps.style, styles.buttonText]}>
                Buy / Renew
              </Text>
            )}
          </Button>

          {Boolean(discount) && (
            <Text style={styles.discountText}>* {discount}</Text>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    width: px(width - 50),
    // height: px(260),
    paddingHorizontal: px(8),
    paddingBottom: px(10),
    borderRadius: 8,
    shadowColor: '#000',
    borderWidth: 1,
    borderColor: '#E5E5E5',
    shadowOffset: {
      width: 3,
      height: 6,
    },
    shadowOpacity: 0.6,
    shadowRadius: 8,
    elevation: 4,
    ...Platform.select({
      ios: {
        borderColor: '#E5E5E5',
        borderWidth: 2,
      },
    }),
  },
  card: {
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: px(8),
  },
  cardImage: {
    borderRadius: 8,
  },
  cardInfo: {
    paddingVertical: px(0),
    flex: 1,
  },
  cardHeading: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabled: {
    opacity: 0.5,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
  },
  desktopImage: {
    width: px(100),
    height: px(100),
    marginHorizontal: 'auto',
  },
  mobileImage: {
    width: px(70),
    height: px(70),
    marginHorizontal: 'auto',
  },
  headingTitletext: {
    fontWeight: '800',
    textAlign: 'center',
    textTransform: 'uppercase',
    textShadowOffset: {width: 1, height: 1},
    textShadowRadius: 1,
    textShadowColor: 'rgba(255, 87, 34, 0.8)',
    fontFamily: 'Poppins',
  },
  headingSubTitletext: {
    fontSize: px(15),
    fontWeight: '700',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontFamily: 'Poppins',
  },
  text2: {
    fontSize: px(13),
    lineHeight: px(20),
    textAlign: 'center',
    fontWeight: '500',
    color: '#FF5722',
    fontFamily: 'Poppins',
  },
  text3: {
    fontSize: px(15),
    lineHeight: px(18),
    marginTop: px(5),
    textAlign: 'center',
    fontWeight: '700',
    color: '#000',
    fontFamily: 'Poppins',
  },
  button: {
    marginTop: px(12),
    maxWidth: px(180),
    marginHorizontal: 'auto',
  },
  buttonText: {
    fontWeight: 'bold',
    fontSize: px(14),
    fontFamily: 'Poppins',
  },
  discountText: {
    fontSize: px(12),
    marginTop: px(10),
    textAlign: 'center',
    color: '#FF5722',
  },
});

export default PackageCard;
